var bLazy;
$(document).ready(function() {
    bLazy = new Blazy({
        selector: ".b-lazy",
        success: function(ele) {
            if(!isMobile && $(ele).closest('#related-wrapper').length > 0){
                fireEvent(window, 'view.related.left.img.loaded');
            }
        }
    });
});